import {
  BookingCountryService,
  BookingCountryServiceOffer,
  BookingService,
  BookingServiceModalityEnum,
  BookingServiceSubModalityEnum,
} from '@repo/common/interfaces';

const getPriceFormatter = (
  locale: string,
  currency: string,
): Intl.NumberFormat => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  });
};

export const formatPrice = (
  fallback: string,
  locale: string,
  offer?: BookingCountryServiceOffer,
) => {
  const amount = offer?.amount;
  const currency = offer?.currency;

  if (!amount || !currency) {
    return fallback;
  }

  return getPriceFormatter(locale, currency).format(amount);
};

/**
 * Some service could be ON_SITE but have a subModality that is REMOTE-like.
 * In this case, the service is shown as REMOTE in the UI (ie store address not shown)
 * @param service
 */
export const isVisuallyRemote = (
  service?: BookingCountryService | BookingService,
): boolean => {
  if (!service) return false;

  return (
    service.modality === BookingServiceModalityEnum.REMOTE ||
    service.subModality === BookingServiceSubModalityEnum.PHONE_CALL ||
    service.subModality === BookingServiceSubModalityEnum.VIDEO_CALL
  );
};

export const isRemote = (
  service?: BookingCountryService | BookingService,
): boolean => {
  if (!service) return false;

  return service.modality === BookingServiceModalityEnum.REMOTE;
};
